import React from "react";
import {Button, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import {useSession} from "../contexts/SessionContext";

const ACTARRAY: {name: string; link: string; role?: string; roles?: string[]}[] = [
    {name: "Plot Team", link: "plot", role:"Loremaster"},
    {name: "Logistics", link: "logistics", role:"Logistics"},
    {name: "Registration Helper", link: "/"},
    {name: "Monster Manager", link: "monsters", role:"MonsterManager"},
    {name: "Plot Item Manager", link: "items", roles: ["Loremaster", "Admin"]},
    {name: "Magic Item Manager", link: "magic-items", roles: ["GM", "Owner", "Admin"]},
    {name: "Treasure Policy Manager", link: "treasure-policy", roles: ["GM", "Owner", "Admin"]},
    {name: "Admin", link: "admin", role:"Admin"}
]

export default function LandingGrid() {
    const {roles: userRoles} = useSession()

    return <React.Fragment>
        <Grid container spacing={2} p={2}>
            {ACTARRAY.map((action) => {
                const visible = action.roles
                    ? action.roles.some(r => userRoles.includes(r))
                    : userRoles.includes(action.role as string)
                if (visible) {
                    return <Grid item md={4} sm={6} xs={12}><Button id={"action-butt-" + action.name}
                                                                    variant="contained"
                                                                    sx={{
                                                                        height: "100%",
                                                                        width: "100%",
                                                                        stretch: "100%",
                                                                        textAlign: "center"
                                                                    }} component={Link}
                                                                    to={action.link}><Typography>{action.name}</Typography></Button></Grid>
                }
            })}</Grid>
    </React.Fragment>
}